import useManageTopicStory from 'hooks/API/useManageTopicStory';
import { useEffect, useState } from 'react';
import { FiEdit } from 'react-icons/fi';
import { useParams } from 'react-router-dom';
import ManageStories from './ManageStories';
import { ReactSortable } from 'react-sortablejs';
import { MdDragIndicator } from 'react-icons/md';
import { AiFillDelete } from 'react-icons/ai';
import { ROLES } from 'utilities/constants';

function TopicStoryTab({ data, subtopicID, userContext }) {
  const { topicID } = useParams();

  const { userInfo = {} } = userContext;
  const isTeacher = userInfo?.data?.key === ROLES.TUTOR;

  const [stories, setStories] = useState([]);
  const [storyEdit, setStoryEdit] = useState(null);

  const { mutate, isLoading } = useManageTopicStory({ topicID });

  useEffect(() => {
    setStories(data?.story);

    const currentSelectedStory = data?.story?.find?.((story) => story?._id === storyEdit?._id);

    if (currentSelectedStory) {
      setStoryEdit(currentSelectedStory);
    }
  }, [data?.story, storyEdit?._id]);

  function generateReOrderData() {
    if (isLoading) return;

    const order = stories.map((story, index) => ({ contentId: story._id, sortPosition: index }));

    // re-order if at least 2 items
    if (order?.length > 1) {
      mutate({ order, type: 'REORDER' });
    }
  }

  function deleteStory(storyID) {
    if (isLoading) return;

    if (storyID === storyEdit?._id) setStoryEdit(null);

    mutate({ storyID, type: 'DELETE' });
  }

  return (
    <div className="container">
      {!isTeacher && (
        <ManageStories
          subtopicID={subtopicID}
          data={data}
          editMode={storyEdit}
          toggle={() => setStoryEdit(null)}
        />
      )}

      <div className="row">
        <div className="col-12">
          <span className=" col-12  mt-5 mb-5 conaddtitle boldtitle">
            Uploaded Stories
            {/* {stories?.length > 1 && (
              <AppButton variantClass="btn-plane g--tint mx-4" onClick={generateReOrderData}>
                Save order
              </AppButton>
            )} */}
          </span>

          {stories?.length > 0 ? (
            <ReactSortable
              list={stories}
              setList={(list) => {
                if (!isTeacher) setStories(list);
              }}
              handle=".non_existinStory_id"
              className="row my-4"
            >
              {stories?.map?.((list) => {
                return (
                  <div
                    className="col-4"
                    key={list.id || list._id}
                    data-id={list.id || list._id}
                    id={list.id || list._id}
                  >
                    <img
                      className="sliderSec-boxImg"
                      src={list?.imageFullUrl || 'https://picsum.photos/300/400'}
                      alt=""
                    />
                    <label className="storytitlename">
                      {!isTeacher && (
                        <>
                          <span className="mx-2" style={{ cursor: 'pointer' }}>
                            <MdDragIndicator className="storyGrabHandleID" />
                          </span>
                          <span
                            className="mx-2"
                            style={{ cursor: 'pointer' }}
                            onClick={() => setStoryEdit(list)}
                          >
                            <FiEdit className="text-info" />
                          </span>
                          <span
                            className="mx-2"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              if (window.confirm('Are you sure you want to delete?')) {
                                deleteStory(list._id);
                              }
                            }}
                          >
                            <AiFillDelete className="text-danger" />
                          </span>
                        </>
                      )}

                      {list?.name || 'Untitled story'}
                    </label>
                  </div>
                );
              })}
            </ReactSortable>
          ) : (
            <div className="text-center">No stories found</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TopicStoryTab;
